






module.exports = {
  "anchor":   {
    "anchor": () => import("../../../components/anchor/anchor.js")
  },
  "search":   {
    "search-autocomplete": () => import("../../../components/search/search-autocomplete.js")
  },
  "slider":   {
    "slider-plugins": () => import("../../../components/slider/slider-plugins.js"),
    "slider": () => import("../../../components/slider/slider.js")
  }
}